import { GatesManagement } from 'features/GatesManagement/GatesManagement';
import { PunchupGatesManagement } from 'features/PunchupPages/GatesManagement';
import { useAppSelector } from 'store/hooks';

const GatesManagementPage = (): JSX.Element => {
	const { isPunchup, greenZoneEnabled } = useAppSelector((state) => state.auth);
	if (isPunchup && greenZoneEnabled) return <PunchupGatesManagement />;
	return <GatesManagement />;
};

export default GatesManagementPage;
